import React from "react"

const Loading = ({ className, ...rest }) => {
  return (
    <div class="ball-loader mx-auto my-8" style={{ maxWidth: "125px" }} role="alert" aria-label="Loading">
      <div class="ball-loader-ball ball1"></div>
      <div class="ball-loader-ball ball2"></div>
      <div class="ball-loader-ball ball3"></div>
    </div>
  )
}

export default Loading
